import dynamic from 'next/dynamic'

export const HelpCenterAction = dynamic(() => import('./help-center-action'))
